import { queryOptions, skipToken, useQuery, UseQueryResult } from '@tanstack/react-query'
import { useAccount } from '@/domain/hooks/useAccount'
import { Address } from 'viem'
import { UserPointsLeaderboardResponseSchema, UserPoints } from '@/features/points/logic/types'

export type UseUserPointsResult = Pick<UseQueryResult<UserPoints>, 'data' | 'isLoading' | 'error'>

export function useUserPoints(): UseUserPointsResult {
  const account = useAccount()

  return useQuery({
    ...userPointsQueryOptions({ account }),
  })
}

export function userPointsQueryOptions({ account }: { account?: Address }) {
  return queryOptions<UserPoints>({
    queryKey: ['season-mew', 'user-points', account],
    queryFn: !account
      ? skipToken
      : async () => {
          const result = await fetch(`/api/points?address=${account}`)

          if (!result.ok) {
            throw new Error('Error fetching user points')
          }

          const json = await result.json()
          const parsed = UserPointsLeaderboardResponseSchema.parse(json)
          return parsed.results[0]!
        },
    enabled: !!account,
    staleTime: Number.POSITIVE_INFINITY,
    refetchInterval: false,
  })
}
